import './Education.css'

const Education = () => {
  return (
    <div>
      
    </div>
  )
}

export default Education
